import React from 'react';
import Class12Fieldtrip2024 from 'views/Class12Fieldtrip2024';
const VissionAndMissionPage = () => {
  return <Class12Fieldtrip2024/>;
};

export default VissionAndMissionPage;